/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITableBrowserViewProps } from './table-browser';

export default (props: ITableBrowserViewProps) => {
    return (
        <>
            {props.searchComponent}
            {props.table}
        </>
    );
};
